var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLamp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 183.235,
    height: 281.214,
    viewBox: "0 0 183.235 281.214",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lamp",
    transform: "translate(-105.422 67.214)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(-154 -8.714)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    y2: 243,
    transform: "translate(309.5 -61)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M1.127,99.327l.074,0A49.764,49.764,0,0,0,48.363,50.187,49.764,49.764,0,0,0,2.314,0a1.135,1.135,0,0,0-.859.3,1.123,1.123,0,0,0-.367.823L0,98.178a1.139,1.139,0,0,0,1.127,1.149Z",
    transform: "matrix(-0.017, -1, 1, -0.017, 260.266, 222.714)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(-70.921 -67.714)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-2",
    "data-name": "Line 1",
    y2: 151,
    transform: "translate(309.5 0.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_445-2",
    "data-name": "Path 445",
    d: "M693.716,325.529l.074,0a49.764,49.764,0,0,0,1.113-99.322,1.135,1.135,0,0,0-.859.3,1.123,1.123,0,0,0-.367.823l-1.088,97.054a1.139,1.139,0,0,0,1.127,1.149Z",
    transform: "matrix(-0.017, -1, 1, -0.017, 46.186, 891.688)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLamp);
export default __webpack_public_path__ + "static/media/lamp.194332d0bf26bf3e4bed751a7135b62f.svg";
export { ForwardRef as ReactComponent };